import { HeaderBannerProps } from './header-banner-model';
import styles from './header-banner.module.scss';

export const HeaderBanner: React.FC<HeaderBannerProps> = ({
  image,
  imageMobile,
  imageAltText,
}) => {
  const altText = imageAltText ?? image.description;

  return (
    <div className={styles.headerBanner}>
      {image && image.url && (
        <img
          className={styles.imageDesktop}
          src={image.url}
          width={image.width}
          height={image.height}
          alt={altText}
        />
      )}
      {imageMobile && imageMobile.url && (
        <img
          className={styles.imageMobile}
          src={imageMobile.url}
          width={imageMobile.width}
          height={imageMobile.height}
          alt={altText}
        />
      )}
    </div>
  );
};
